import React, { useMemo } from 'react'
import { Language } from '@graphics/gfx-common/dist/constants'
import { IEditionMetadata } from '../../types/pack'
import { getMediaTypeLabel } from '../../services/editionsHelpers'
import { splitFileNameExt } from '../../services/file'
import { Space } from '../../layouts'
import { StyledNavLink } from '../StyledNavLink'
import { DeletedFileWarningIcon } from '../DeletedFileWarningIcon'
import { EditionStatus } from './EditionStatus'
import { FileTreeIcon, FileTreeTypes } from './FileTreeIcon'
import { FileTreeCheck } from './FileTreeCheck'
import {
  StyledFlexRow,
  StyledFileTitle,
  StyledFileDetails,
  StyledLanguage,
  StyledFileExt,
} from './styled'

export interface IFileItem {
  id?: string
  edition: IEditionMetadata
  href: string
  isActive: () => boolean
  isSecondLevel?: boolean
  defaultLanguage: Language | ''
  error: string | false
}

export const FileItem = ({
  edition,
  id,
  href,
  isActive,
  isSecondLevel,
  defaultLanguage,
  error,
}: IFileItem) => {
  const { mediaType, editionName, publishing, language, file } = edition
  const { name, extension } = useMemo(() => {
    return splitFileNameExt(editionName)
  }, [editionName])
  const displayLanguage = language || defaultLanguage
  const isFileDeleted = file && file.deleted
  return (
    <StyledNavLink
      id={id}
      to={href}
      isActive={isActive}
      theme="green"
      style={isSecondLevel ? { paddingLeft: '44px' } : {}}
    >
      <div>
        <StyledFlexRow>
          <FileTreeIcon
            mediaType={
              mediaType === 'Image'
                ? FileTreeTypes.image
                : FileTreeTypes.archive
            }
          />
          <StyledFileTitle title={editionName}>{name}</StyledFileTitle>
          {extension && <StyledFileExt>{`.${extension}`}</StyledFileExt>}
          <FileTreeCheck
            status={
              publishing.publishing ? 'publishing' : error ? 'error' : 'done'
            }
            genericError={error}
          />
        </StyledFlexRow>
      </div>
      <StyledFileDetails>
        <div>
          <EditionStatus publishing={publishing} />
          <Space mt={1}>
            {displayLanguage && (
              <StyledLanguage>{displayLanguage}</StyledLanguage>
            )}{' '}
            {getMediaTypeLabel(edition)}
          </Space>
        </div>
        {isFileDeleted && (
          <div>
            <DeletedFileWarningIcon />
          </div>
        )}
      </StyledFileDetails>
    </StyledNavLink>
  )
}
